import {Component} from '@angular/core';
import {BsModalService} from "ngx-bootstrap/modal";
import {CartService} from "../cart.service";
import {take} from "rxjs/operators";
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";
import {LoginModalService} from "../../login/login-modal.service";
import {Constants} from "../../constants";

@Component({
    selector: 'pc-upsell',
    templateUrl: './pc-upsell-modal.component.html',
    styleUrls: ['./pc-upsell-modal.component.scss'],
    standalone: false
})
export class PcUpsellModalComponent extends BaseComponent {
    readonly Constants = Constants;

    constructor(
        private userService: UserService,
        private loggerService: LoggerService,
        private loginModalService: LoginModalService,
        private modalService: BsModalService,
        private cartService: CartService
    ) {
        super(userService, loggerService);
    }

    goToLogin() {
        this.loginModalService.openLogin().pipe(take(1)).subscribe();
    }

    goToCheckout() {
        this.closeModals();
        this.cartService.checkout();
    }

    closeModals() {
        this.modalService.hide(this.cartService.pcUpsellModalRef.id);
    }
}
